/*
 * Module for the Benefit Payment History Index view
*/
rs.module("ui/content/benefits/paymenthistory/index",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // Unpack Js Selectors
            var yearSelect = $.js(jsSelectors.yearSelect, { required: false });
            var paymentHistory = $.js(jsSelectors.paymentHistory);
            var skeleton = $.js(jsSelectors.skeleton, { required: false });

            // Handle the year select change event.
            yearSelect.change(function () {

                // Show skeleton while we load content.
                skeleton.show();
                paymentHistory.hide();

                // Retrieve payment history list
                $.get(backendUrls.getPaymentHistory,
                    {
                        appliesToYear: $(this).val()
                    })
                    .done(function (html) {
                        paymentHistory.html(html);
                    })
                    .always(function () {
                        skeleton.hide();
                        paymentHistory.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);